import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../core/services/auth.service';
import { BusinessContextService } from '../core/services/business-context.service';
import { NavigationService } from '../core/services/navigation.service';

@Component({
  selector: 'app-dashboard-redirector',
  standalone: true,
  template: '',
})
export class DashboardRedirector implements OnInit {
  private router = inject(Router);
  private authService = inject(AuthService);
  private bizCtx = inject(BusinessContextService);
  private navService = inject(NavigationService);

  ngOnInit() {
    const isSA = this.authService.isSuperAdmin;
    const hasCtx = this.bizCtx.hasContext();

    // Determinar permiso requerido
    const requiredPermission = (isSA && !hasCtx) ? 'system:dashboard' : 'dashboard:list';
    
    // Verificar permiso
    const hasAccess = isSA 
      ? this.authService.hasPermission(requiredPermission)
      : this.bizCtx.hasPermission(requiredPermission);

    if (hasAccess) {
      if (isSA && !hasCtx) {
        this.router.navigate(['/app/system-dashboard'], { replaceUrl: true });
      } else {
        this.router.navigate(['/app/clinical-dashboard'], { replaceUrl: true });
      }
    } else {
      // Si no hay acceso al dashboard, ir a la primera ruta permitida
      const fallback = this.navService.getFirstValidRoute();
      this.router.navigate([fallback], { replaceUrl: true });
    }
  }
}
